document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;

  var SELECTOR = '.kv-pack__cta, .banner__buttons .button, .rich-text__buttons .button, .kv-wheel-form__button:not(.kv-wheel-shop-link)';
  var STRENGTH = 0.25;
  var MAX_OFFSET = 10;

  document.querySelectorAll(SELECTOR).forEach(function (button) {
    button.classList.add('kv-magnetic');

    button.addEventListener('mousemove', function (event) {
      var rect = button.getBoundingClientRect();
      var offsetX = event.clientX - (rect.left + rect.width / 2);
      var offsetY = event.clientY - (rect.top + rect.height / 2);
      var x = Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, offsetX * STRENGTH));
      var y = Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, offsetY * STRENGTH));
      button.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    });

    button.addEventListener('mouseleave', function () {
      button.style.transform = '';
    });
  });
});
